import { render, staticRenderFns } from "./GroupUsers.vue?vue&type=template&id=af744b38&scoped=true"
import script from "./GroupUsers.vue?vue&type=script&lang=js"
export * from "./GroupUsers.vue?vue&type=script&lang=js"
import style0 from "./GroupUsers.vue?vue&type=style&index=0&id=af744b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af744b38",
  null
  
)

export default component.exports